module.exports = __webpack_public_path__ + "img/can-am.5fd9929e.jpg";